import React, { FC } from 'react';
import { FormControlLabel, Radio, RadioGroup, useTheme } from '@mui/material';

import { useThemeMode, useTranslate } from 'src/shared/providers';
import './DisplayPreferences.styles.scss';

export const DisplayThemeForm: FC = () => {
  const { t } = useTranslate();
  const theme = useTheme();
  const { toggleThemeMode } = useThemeMode();

  const handleModeChange = (mode: string) => {
    if (mode !== 'light' && mode !== 'dark') {
      return;
    }

    toggleThemeMode(mode);
  };

  return (
    <div className="my-4 d-flex align-items-center flex-wrap">
      <div className="display-preferences-header">
        <p className="mb-0 fw-500">{t('settings.chooseTheme')}</p>
        <label className="text-muted d-block">{t('settings.chooseAThemeToViewThisApplicationIn')}</label>
      </div>
      <div className="">
        <RadioGroup
          className="flex-row mt-3 mt-md-0"
          value={theme.palette.mode}
          onChange={(_, value: string) => handleModeChange(value)}
        >
          <FormControlLabel
            id="light-theme-radio-btn"
            className="preferences-radio-btn"
            value="light"
            control={<Radio />}
            label={t('settings.lightMode')}
          />
          <FormControlLabel
            id="dark-theme-radio-btn"
            className="preferences-radio-btn"
            value="dark"
            control={<Radio />}
            label={t('settings.darkMode')}
          />
        </RadioGroup>
      </div>
    </div>
  );
};
